<template>
  <v-container fluid class="d-flex flex-column align-center">
    <div class="text-center" style="max-width: 400px; width: 100%; padding-top: 40px;">
      <v-icon size="64" color="error" class="mb-4">fas fa-exclamation-circle</v-icon>

      <h2 class="mb-4" v-if="error === 'expired'">{{ $t('auth.magicLink.expiredTitle') }}</h2>
      <h2 class="mb-4" v-else-if="error === 'notfound'">{{ $t('auth.magicLink.notFoundTitle') }}</h2>
      <h2 class="mb-4" v-else>{{ $t('auth.magicLink.errorTitle') }}</h2>

      <p class="mb-6" v-if="error === 'expired'">{{ $t('auth.magicLink.expiredMessage') }}</p>
      <p class="mb-6" v-else-if="error === 'notfound'">{{ $t('auth.magicLink.notFoundMessage') }}</p>
      <p class="mb-6" v-else>{{ $t('auth.magicLink.errorMessage') }}</p>

      <Button
        @click.native="goToLogin"
        width="200"
        margin="0 auto"
        :title="$t('auth.magicLink.backToLogin')"
      ></Button>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "neoparent-magic-link-error",
  props: {
    error: {
      type: String,
      default: ""
    }
  },
  methods: {
    goToLogin() {
      window.location.href = "/login";
    }
  }
};
</script>

<style scoped lang="scss">
</style>

